import { excludeAbortError } from '@app/errors/AbortError'

import { createSelector } from '@app/utils/createSelector'

import type { ApiTrainingRequest } from '@app/packages/api/v2/types/entities'
import { asError } from '@app/packages/asError/asError'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const trainingRequestConfirmationSlice = createReduxSlice<Record<string, ApiTrainingRequest | Error | undefined>>('training_request_confirmation')

/** The screen reads the outcome for its token out of here, so both outcomes are recorded. */
export const confirmTrainingRequest = (token: string) =>
  createThunk(async dispatch => {
    const [{ postTrainingRequestConfirmation }, { callV2Api }] = await Promise.all([
      import('@app/packages/api/v2/actions/training_request'),
      import('@app/store/actions/api'),
    ])
    try {
      const resp = await dispatch(callV2Api(postTrainingRequestConfirmation(token)))
      dispatch(trainingRequestConfirmationSlice.update(state => ({ ...state, [token]: resp.data })))
      return resp
    } catch (e) {
      dispatch(trainingRequestConfirmationSlice.update(state => ({ ...state, [token]: excludeAbortError(asError(e)) ?? undefined })))
      throw e
    }
  })

export const trainingRequestConfirmationsSelector = createSelector([trainingRequestConfirmationSlice.selector], confirmations => confirmations ?? {})
